import React from 'react';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import Navbar from '../common/Navbar';
import GradingInterface from '../admin/GradingInterface';

const ViewerDashboard = ({ user, onLogout }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default' }}>
      <Navbar user={user} onLogout={onLogout} />

      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" gutterBottom color="primary">
          {t('viewer.dashboard')}
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {t('viewer.assignedCandidates')}
        </Typography>

        {/* Use the same GradingInterface component in read-only mode */}
        <GradingInterface readOnly={true} viewerId={user.id} />
      </Container>
    </Box>
  );
};

export default ViewerDashboard;
